<template>
  <div class="comment-form">
    <CommentInput :value="value" @input="emitChange" />
    <PrimaryBtn v-if="$store.state.id" class="btn--comment" @click="emitConfirm" :disabled="value.length===0">{{ $t('common.comment') }}</PrimaryBtn>
    <LoginButton v-else class="btn--login btn--comment" :label="$t('common.comment')" @login="$emit('login')" />
  </div>
</template>

<script>
import CommentInput from '@/components/CommentInput.vue';
import PrimaryBtn from '@/components/PrimaryBtn.vue';
import LoginButton from '@/components/LoginButton.vue';

export default {
  name: 'CommentForm',
  components: { LoginButton, PrimaryBtn, CommentInput },
  props: {
    value: {
      type: String,
      require: true,
      default: '',
    },
  },
  methods: {
    emitConfirm() {
      this.$emit('confirm', this.value);
    },
    emitChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .comment-form {
    overflow: hidden;
  }

  .btn--comment {
    float: right;
    margin-top: $padding-sm;
  }

  .btn--login {
    width: auto;
  }
</style>
